export const getCookie = (name: string): string | null => {
  try {
    const match = new RegExp('(^| )' + name + '=([^;]+)').exec(document.cookie)
    return match ? decodeURIComponent(match[2]) : null
  } catch {
    return null
  }
}
//cop powerportal flag is set to true when the user is a cop user and false when the user is not a cop user
export const isCopEnabled = (): boolean => getCookie('cop_powerportal_flag') === 'true'
